import { defineMessages } from "react-intl";

export default defineMessages({
  favoriteError: {
    id: "partners.Favorite.favoriteError",
    defaultMessage:
      "There was an error favoriting/unfavoriting publishers, please refresh and try again.",
  },
});
